// extracted by mini-css-extract-plugin
module.exports = {"userSelect_none":"_82e3db2ea0--userSelect_none--g_J_6","userSelect_auto":"_82e3db2ea0--userSelect_auto--f5UVj","userSelect_all":"_82e3db2ea0--userSelect_all--v9qxk"};